<a class="dropdown-item" [ngClass]="{ 'checkbox': hasCheckbox }" [attr.title]="titleKey !== '' ? (titleKey | translate) : null">
    <ng-content></ng-content>
</a>
